var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtboard1Copy304(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 608.2 446.5",
    style: {
      enableBackground: "new 0 0 608.2 446.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9EFF2E;}\n\t.st1{fill:#7CE25A;}\n\t.st2{fill:#231F20;}\n\t.st3{fill:#BE1E2D;}\n\t.st4{fill:#FFDD15;}\n\t.st5{fill:#1B75BB;}\n\t.st6{fill:#009345;}\n\t.st7{fill:#9F1622;}\n\t.st8{fill:#13588E;}\n\t.st9{fill:#006838;}\n\t.st10{fill:#C4AA15;}\n\t.st11{fill:none;}\n\t.st12{fill:#E8D92A;}\n\t.st13{fill:#E12626;}\n\t.st14{fill:#44B449;}\n\t.st15{fill:#3777BC;}\n\t.st16{fill:#45B549;}\n\t.st17{fill:#3677BB;}\n\t.st18{fill:#E8D828;}\n\t.st19{fill:#215584;}\n\t.st20{fill:#21782E;}\n\t.st21{fill:#837F12;}\n\t.st22{fill:#10C685;}\n\t.st23{fill:none;stroke:#FCB01A;stroke-width:6;stroke-miterlimit:10;}\n\t.st24{fill:#A51C3D;}\n\t.st25{fill:#00904C;}\n\t.st26{fill:#702634;}\n\t.st27{fill:#FF1A3B;}\n\t.st28{fill:#FC83B2;}\n\t.st29{fill:#413470;}\n\t.st30{fill:#6C42E2;}\n\t.st31{fill:#B076F4;}\n\t.st32{fill:#0F4417;}\n\t.st33{fill:#BB3A07;}\n\t.st34{fill:#7F2602;}\n\t.st35{fill:#F95B1C;}\n\t.st36{fill:#FFA60D;}\n\t.st37{fill:url(#);}\n\t.st38{fill:url(#SVGID_1_);}\n\t.st39{fill:url(#SVGID_00000148661039926447327430000013905487381853602708_);}\n\t.st40{fill:url(#SVGID_00000158712244684005555910000001435795326496042385_);}\n\t.st41{fill:url(#SVGID_00000090295766103134243040000010973261436457226885_);}\n\t.st42{fill:url(#SVGID_00000160181237096358698550000006758556488403581099_);}\n\t.st43{fill:url(#SVGID_00000061439195113969595090000004468608110842847422_);}\n\t.st44{fill:url(#SVGID_00000021798186006597177720000000010756286646623669_);}\n\t.st45{fill:url(#SVGID_00000093874804875827075300000008510294797563974789_);}\n\t.st46{fill:url(#SVGID_00000091728862316233430940000008167989681439675838_);}\n\t.st47{fill:url(#SVGID_00000175318063576213320860000006004991530815801016_);}\n\t.st48{fill:url(#SVGID_00000130640021760345130680000007033606187160209853_);}\n\t.st49{fill:url(#SVGID_00000177453319619892333270000018065771185733474970_);}\n\t.st50{fill:url(#SVGID_00000060721910275604518460000016993464098401267331_);}\n\t.st51{fill:url(#SVGID_00000174563662278220247570000018199816909812165298_);}\n\t.st52{fill:url(#SVGID_00000071558496134572461530000005596430114814224564_);}\n\t.st53{fill:url(#SVGID_00000116938103182286734320000000708659228723475366_);}\n\t.st54{fill:url(#SVGID_00000039819975913946678840000012057696353411946908_);}\n\t.st55{fill:url(#SVGID_00000060737050221808820490000007700925172250743473_);}\n\t.st56{fill:url(#SVGID_00000160180229642224565250000003703512887489900449_);}\n\t.st57{fill:url(#SVGID_00000067219697863690604260000003862733224827808387_);}\n\t.st58{fill:url(#SVGID_00000176036770438992481470000006211003116246334622_);}\n\t.st59{fill:url(#SVGID_00000172415799766594245490000002093380150220501904_);}\n\t.st60{fill:url(#SVGID_00000005966209944924502630000003721932776928890291_);}\n\t.st61{fill:url(#SVGID_00000044890459007210769140000017355506320791841447_);}\n\t.st62{fill:url(#SVGID_00000080193406390312747860000010399308917442812597_);}\n\t.st63{fill:url(#SVGID_00000122705696143039999530000016567670842207767966_);}\n\t.st64{fill:url(#SVGID_00000049184605519956655140000017615744372192156558_);}\n\t.st65{fill:url(#SVGID_00000103986895647051466830000011049155202901751989_);}\n\t.st66{fill:url(#SVGID_00000150817369720910487750000011552179427385490863_);}\n\t.st67{fill:url(#SVGID_00000181806571867350562710000008527962624238602894_);}\n\t.st68{fill:url(#SVGID_00000154398730993295578450000011276816952232792492_);}\n\t.st69{fill:url(#SVGID_00000099634838737498363140000007019397609486283654_);}\n\t.st70{fill:url(#SVGID_00000144336219081346762640000002918974476176582018_);}\n\t.st71{fill:url(#SVGID_00000054244087798904051120000007183010552435200135_);}\n\t.st72{fill:url(#SVGID_00000073722786031220967870000008403053526677121413_);}\n\t.st73{fill:url(#SVGID_00000029764927533649569630000007732352799552233647_);}\n\t.st74{fill:url(#SVGID_00000054961388728942259120000010706668907660257677_);}\n\t.st75{fill:url(#SVGID_00000089542698733764513170000001680244286311543442_);}\n\t.st76{fill:url(#SVGID_00000047766637437092098610000015305650974872081596_);}\n\t.st77{fill:url(#SVGID_00000022555301346730872300000001378918126677003680_);}\n\t.st78{fill:url(#SVGID_00000178164300688499360470000017229079359373668484_);}\n\t.st79{fill:url(#SVGID_00000094619006334898695310000018208017083192461732_);}\n\t.st80{fill:url(#SVGID_00000117650207684900189410000006379342442364549281_);}\n\t.st81{fill:url(#SVGID_00000090276624055176823330000004013937557138830506_);}\n\t.st82{fill:url(#SVGID_00000146459360006309722060000000153938780642229424_);}\n\t.st83{fill:url(#SVGID_00000145750460378627998900000004746227107108786326_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "608.2,197.4 608.2,320.4 420.5,320.4 420.5,257.9 420.5,257.9 420.5,197.4 483.1,197.4 483.1,257.9  545.6,257.9 545.6,257.9 545.6,257.9 545.6,257.9 545.6,257.9 545.6,197.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M608.2,134.8v62.5H420.5v-62.5h5.6v-7.5c0,1,4.7,1.8,10.6,1.8c5.8,0,10.5-0.8,10.5-1.8v7.5h9.8v-7.5 c0,1,4.7,1.8,10.6,1.8c5.8,0,10.6-0.8,10.6-1.8v7.5h10v-7.5c0,1,4.7,1.8,10.6,1.8c5.8,0,10.6-0.8,10.6-1.8v7.5h9.7v-7.5 c0,1,4.7,1.8,10.5,1.8c5.8,0,10.5-0.8,10.5-1.8v7.5h10.9v-7.5c0,1,4.7,1.8,10.5,1.8c5.8,0,10.6-0.8,10.6-1.8v7.5h9.8v-7.5 c0,1,4.7,1.8,10.6,1.8c5.8,0,10.6-0.8,10.6-1.8v7.5H608.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.6,
    y: 257.9,
    className: "st3",
    width: 0,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.6,
    y: 257.9,
    className: "st3",
    width: 0,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 71.3,
    className: "st5",
    width: 62.5,
    height: 250.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.7,
    className: "st3",
    width: 62.5,
    height: 62.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "393.1,258.9 393.1,446.5 268,446.5 268,384 330.5,384 330.5,321.4 268,321.4 268,196.4 330.5,196.4  330.5,258.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.6,
    y: 133.8,
    className: "st6",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 133.8,
    className: "st6",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "393.1,133.8 393.1,196.4 268,196.4 268,133.8 275.6,133.8 275.6,135 296.7,135 296.7,133.8  306.5,133.8 306.5,135 327.6,135 327.6,133.8 337.5,133.8 337.5,135 358.6,135 358.6,133.8 368.4,133.8 368.4,135 389.5,135  389.5,133.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.5,
    y: 133.8,
    className: "st6",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.4,
    y: 133.8,
    className: "st6",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 133.8,
    className: "st5",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 133.8,
    className: "st5",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.1,
    y: 196.4,
    className: "st5",
    width: 0,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "230.6,133.8 230.6,196.4 168.1,196.4 168.1,196.4 105.5,196.4 105.5,133.8 112.5,133.8 112.5,135  133.6,135 133.6,133.8 143.4,133.8 143.4,135 164.5,135 164.5,133.8 174.4,133.8 174.4,135 195.5,135 195.5,133.8 205.3,133.8  205.3,135 226.4,135 226.4,133.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.4,
    y: 133.8,
    className: "st5",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.3,
    y: 133.8,
    className: "st5",
    width: 21.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.1,
    y: 196.4,
    className: "st5",
    width: 62.5,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "168.1,227.6 168.1,258.9 230.6,258.9 230.6,321.4 105.5,321.4 105.5,196.4 230.6,196.4 230.6,227.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.1,
    y: 196.4,
    className: "st6",
    width: 62.6,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 1.8,
    className: "st3",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.1,
    y: 1.8,
    className: "st3",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 15.8,
    cy: 1.8,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 46.6,
    cy: 1.8,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 127.4,
    className: "st5",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 127.4,
    className: "st5",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 123.1,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 153.9,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.4,
    y: 127.4,
    className: "st5",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.3,
    y: 127.4,
    className: "st5",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 185,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 215.8,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.6,
    y: 127.4,
    className: "st6",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 127.4,
    className: "st6",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 286.2,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 317,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.5,
    y: 127.4,
    className: "st6",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.4,
    y: 127.4,
    className: "st6",
    width: 21.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 348.1,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 378.9,
    cy: 127.4,
    rx: 10.5,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M447.2,127.4c0,1-4.7,1.8-10.5,1.8c-5.8,0-10.6-0.8-10.6-1.8H447.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M478.1,127.4c0,1-4.7,1.8-10.6,1.8c-5.8,0-10.6-0.8-10.6-1.8H478.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M447.2,127.4c0,1-4.7,1.8-10.5,1.8c-5.8,0-10.6-0.8-10.6-1.8c0-1,4.7-1.8,10.6-1.8 C442.5,125.6,447.2,126.4,447.2,127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M478.1,127.4c0,1-4.7,1.8-10.6,1.8c-5.8,0-10.6-0.8-10.6-1.8c0-1,4.7-1.8,10.6-1.8 C473.4,125.6,478.1,126.4,478.1,127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M509.2,127.4c0,1-4.7,1.8-10.6,1.8c-5.8,0-10.6-0.8-10.6-1.8H509.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M540,127.4c0,1-4.7,1.8-10.5,1.8c-5.8,0-10.5-0.8-10.5-1.8H540z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M509.2,127.4c0,1-4.7,1.8-10.6,1.8c-5.8,0-10.6-0.8-10.6-1.8c0-1,4.7-1.8,10.6-1.8 C504.4,125.6,509.2,126.4,509.2,127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M540,127.4c0,1-4.7,1.8-10.5,1.8c-5.8,0-10.5-0.8-10.5-1.8c0-1,4.7-1.8,10.5-1.8 C535.3,125.6,540,126.4,540,127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M572,127.4c0,1-4.7,1.8-10.6,1.8c-5.8,0-10.5-0.8-10.5-1.8H572z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.9,127.4c0,1-4.7,1.8-10.6,1.8c-5.8,0-10.6-0.8-10.6-1.8H602.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M572,127.4c0,1-4.7,1.8-10.6,1.8c-5.8,0-10.5-0.8-10.5-1.8c0-1,4.7-1.8,10.5-1.8 C567.3,125.6,572,126.4,572,127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M602.9,127.4c0,1-4.7,1.8-10.6,1.8c-5.8,0-10.6-0.8-10.6-1.8c0-1,4.7-1.8,10.6-1.8 C598.1,125.6,602.9,126.4,602.9,127.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard1Copy304);
export default __webpack_public_path__ + "static/media/Artboard 1 copy 3-04.6c3d6d4ad3521785c008735bf2fcde87.svg";
export { ForwardRef as ReactComponent };